import { atom, useAtom } from "jotai";

import { DesignElementManager, type DesignElementManagerType } from ".";

const designElementManagerAtom = atom<DesignElementManagerType>(
  new DesignElementManager() as DesignElementManagerType,
);

const designElementManagerAtomV2 = atom<DesignElementManagerType>(
  new DesignElementManager("v2") as DesignElementManagerType,
);

export const useDesignElementManager = () => {
  const [designElementManager] = useAtom(designElementManagerAtom);
  return { designElementManager };
};

export const useDesignElementManagerV2 = () => {
  const [designElementManager] = useAtom(designElementManagerAtomV2);
  return { designElementManager };
};
